import axios from '../utils/axios';

class DefaultEntityService {
  constructor() {}
  get() {
    return axios.get('/default-entities');
  }

  create(body) {
    return axios.put('/default-entities', body);
  }
}

export default new DefaultEntityService();
